<template>
  <BaseButton
    v-if="isVisible"
    :loading="isDownloading"
    size="sm"
    @click="handleDownload"
    >Download</BaseButton
  >
</template>

<script>
import { defineComponent, computed, inject, ref } from '@vue/composition-api'
import { saveAs } from 'file-saver'

import { useUserCompany } from '@composables'
import { GlobalUMRs } from '@services'

import { BaseButton } from '@components/base'

export default defineComponent({
  name: 'BDXStatusModalDownloadButton',
  components: {
    BaseButton
  },
  setup() {
    const { roleName: companyRoleName, roleValue: companyRoleValue } =
      useUserCompany()

    const { filters, pagination } = inject('global-umr-modal')

    const isVisible = computed(() => {
      const filterValues = Object.values(filters.value).filter(
        (value) => !!value
      )

      if (1 === filterValues.length) return 'All' !== filterValues[0]

      return !!filterValues.length
    })

    const isDownloading = ref(false)

    const handleDownload = async () => {
      isDownloading.value = true

      try {
        const res = await GlobalUMRs.getItems({
          ...filters.value,
          ...pagination.value,
          role: companyRoleName.value,
          role_value: companyRoleValue.value,
          sort: 'umr',
          download: true
        })
        const { data } = res || {}

        isDownloading.value = false

        saveAs(data, `Global UMRs.xlsx`)
      } catch (_) {
        isDownloading.value = false
      }
    }

    return {
      isVisible,

      isDownloading,
      handleDownload,

      pagination
    }
  }
})
</script>
